import {HTTP} from "@/http";

class EntraConnectionServiceClass {
  basePath = 'api/v2/entra-connections';

  /**
   * Get all Entra connections
   * @returns {Promise<Object>}
   */
  getAll() {
    return HTTP.get(this.basePath);
  }

  /**
   * Get a single Entra connection by ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  getById(id) {
    return HTTP.get(`${this.basePath}/${id}`);
  }

  /**
   * Create a new Entra connection.
   * @param {Object} connection { entraTenantId, registrationId, tenantId? }
   * @returns {Promise<Object>}
   */
  create(connection) {
    return HTTP.post(this.basePath, connection);
  }

  /**
   * Update an existing Entra connection
   * @param {Object} connection Connection object including its id
   * @returns {Promise<Object>}
   */
  patch(connection) {
    return HTTP.patch(`${this.basePath}/${connection.id}`, connection);
  }

  /**
   * Validate an Entra connection without persisting it.
   * @param {Object} connection { id?, tenantId?, registrationId, entraTenantId }
   * @returns {Promise<Object>} resolves with EntraConnectionValidationResponseView
   */
  validate(connection) {
    if (connection.id) {
      return HTTP.post(`${this.basePath}/${connection.id}/validate`, {
        registrationId: connection.registrationId,
        entraTenantId: connection.entraTenantId,
      });
    }

    const body = {
      registrationId: connection.registrationId,
      entraTenantId: connection.entraTenantId,
    };
    if (connection.tenantId) {
      body.tenantId = connection.tenantId;
    }
    return HTTP.post(`${this.basePath}/validate`, body);
  }

  /**
   * Delete an Entra connection by ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  delete(id) {
    return HTTP.delete(`${this.basePath}/${id}`);
  }

  getAdminConsentUrl(entraTenantId, redirectUri) {
    return HTTP.get(`${this.basePath}/admin-consent-url`, {params: {entraTenantId, redirectUri}});
  }
}

/**
 * @type {EntraConnectionServiceClass}
 */
export const entraConnectionService = new EntraConnectionServiceClass();
